// import { useSelector } from "react-redux";
// import { Navigate, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const location = useLocation();
//   const { loading, isAuthenticated } = useSelector((state) => state.user);

//   // Wait until auth status is known
//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   // Redirect if not authenticated
//   if (!isAuthenticated) {
//     return (
//       <Navigate
//         to="/login"
//         replace
//         state={{ previousUrl: location.pathname }}
//       />
//     );
//   }

//   // Render protected content
//   return children;
// };

// export default ProtectedRoute;
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { loading, loaded, isAuthenticated } = useSelector(
    (state) => state.user,
  );
  const location = useLocation();

  useEffect(() => {
    if (loading) {
      toast.loading("Checking authentication...", {
        id: "auth-loading",
      });
    } else {
      toast.dismiss("auth-loading");
    }
  }, [loading]);

  // Don't decide anything until the initial auth check has actually finished
  if (!loaded || loading) {
    return null; // or a spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
